import { User, UserRole } from "../../entity/User";
import Pair from "../../types/Pair";
import { toDate } from "../../utils/GlobalFunctions";
import { AuthResponse, UserDTO, UsersResponse } from "../dto/User.dto";

/**
 * Map an AuthResponse to User
 * @param data AuthResponse
 * @returns User
 */
export const mapTOUserDTO = (data: AuthResponse): User => {
  return {
    token: data.token,
    email: data.user.email,
    id: data.user.id,
    role: data.user.role as User["role"],
    storeId: data.user.storeId,
  };
};

/**
 * Map an array of UserDTO to an array of User
 * @param data UserDTO[]
 * @returns User[]
 */
export const mapToUsers = (data: UserDTO[]): User[] => {
  return data.map((user) => {
    return {
      id: user.id,
      email: user.email || "",
      role: user.role || UserRole.USER,
      createdAt: user.createdAt ? toDate(user.createdAt) : new Date(),
      updatedAt: user.updatedAt ? toDate(user.updatedAt) : new Date(),
      phone: user.phone,
      address: user.address,
      username: user.username,
      isActive: user.isActive,
      storeId: user.storeId,
    };
  });
};

/**
 * Map a single UserDTO to User
 * @param user UserDTO
 * @returns User
 */
export const mapToUser = (user: UserDTO): User => {
  return {
    id: user.id,
    email: user.email || "",
    password: user.password || "",
    role: user.role || UserRole.USER,
    createdAt: toDate(user.createdAt),
    updatedAt: toDate(user.updatedAt),
    isActive: user.isActive,
  };
};

/**
 * Map a UsersResponse to Pair<User[], string>
 * @param userResponseDto UsersResponse
 * @returns Pair<User[], string>
 */
export const mapUserResponseToUsers = (
  userResponseDto: UsersResponse,
): Pair<User[], string> => {
  return {
    first: mapToUsers(userResponseDto.users),
    second: userResponseDto.nextCursor,
  };
};
